import * as React from "react";
import { observer } from "mobx-react";
import i18n from "i18n";
import { WBSStore } from "modules/WBS/WBSStore";
import { Typography, CircularProgress, withStyles } from "@material-ui/core";

const styles = (theme) => ({
  box: {
    backgroundColor: "rgba(255,255,255,.95)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column" as any,
    position: "absolute" as any,
    width: "100%",
    height: "100%",
    top: "0px",
    left: "0px",
    zIndex: 999991,
    textTransform: "uppercase" as any,
  },
  loaderText: {
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "14px",
    lineHeight: "26px",
  },
});

type IProps = {
  classes: any;
};

@observer
class UpdateCompositionsLoading extends React.Component<IProps> {
  render() {
    const { classes } = this.props;

    const message = (type) => {
      if (type == "compareCompositions") {
        return i18n.updateCompositions.checkingProject;
      } else {
        return i18n.updateCompositions.updatingProject;
      }
    };
    return WBSStore.WBS.data.updateCompositions &&
      (WBSStore.WBS.data.updateCompositions.isProcessing ||
        WBSStore.WBS.data.updateCompositions.totalCompositions !=
          WBSStore.WBS.data.updateCompositions.count) ? (
      <div className={classes.box}>
        <CircularProgress style={{ color: "#9AAF00", marginBottom: "35px" }} />
        <Typography variant="body1" className={classes.loaderText}>
          {WBSStore.WBS.data.updateCompositions.progress}%
        </Typography>
        <Typography variant="h6" className={classes.loaderText}>
          {message(WBSStore.WBS.data.updateCompositions.type)}...
        </Typography>
      </div>
    ) : (
      <></>
    );
  }
}

export default withStyles(styles)(UpdateCompositionsLoading);



// WEBPACK FOOTER //
// ./src/modules/WBS/components/layouts/UpdateCompositionsLoading.tsx